import { sprinkles, type Sprinkles } from '../css/sprinkles.css';

export function extractProps(props: Record<string, unknown>, recipeVariants?: Set<string>) {
	const sprinkleProps: Record<string, unknown> = {};
	const recipeProps: Record<string, unknown> = {};
	const restProps: Record<string, unknown> = {};

	for (const key in props) {
		if (sprinkles.properties.has(key as keyof Sprinkles)) {
			sprinkleProps[key] = props[key as keyof typeof props];
		} else if (recipeVariants != null && recipeVariants.has(key)) {
			recipeProps[key] = props[key as keyof typeof props];
		} else {
			restProps[key] = props[key as keyof typeof props];
		}
	}

	return {
		sprinkleProps,
		recipeProps,
		restProps,
	};
}
